import { Injectable } from '@angular/core';
import { appSettings, errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { DashboardService } from "../dashboard.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class UserperformanceService extends BaseService  {

  constructor( private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService) {
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget);
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {

    widget.hub.listenFor("broadcastUserActivity").subscribe(
      (data: any) => {
        console.log("broadcastUserActivity", data);
        let result: Array<any> = [];
        result = data;
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime && !widget.IfNoDataFound) {
          widget.dataLoaded = false;
         
          widget.errorMessage = null;
          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
            let Report_Periods = [];          
            let PackedUsersPerf = [];
            let PickedUsersPerf = [];
            let ReplenUsersPerf = [];

            for (let i = 0; i < result.length; i++) {
              let rptdate = "";
              rptdate = this._commonService.formatDate(result[i].ReportDate,appSettings.chartDayHrFormat2);
              if (rptdate != '' && Report_Periods.indexOf(rptdate) == -1) {
                Report_Periods.push(rptdate);

                PackedUsersPerf.push([rptdate,result[i].PickedUserPerformance,
                        'Units ' + result[i].PackedUnitsCount,'Users ' + result[i].PackedUsersCount]);
                PickedUsersPerf.push([rptdate,result[i].PackedUserPerformance,
                        'Units ' + result[i].PickedUnitsCount,'Users ' + result[i].PickedUsersCount]);
                ReplenUsersPerf.push([rptdate,result[i].ReplenUserPerformance,
                        'Units ' + result[i].ReplenUnitsCount,'Users ' + result[i].ReplenUsersCount]);
              }            
            }

            widget.chartOptions = this.chartOptions();
            this.addDataSeries(widget.chartOptions, PackedUsersPerf, 'Packed Performance', 'line')
            this.addDataSeries(widget.chartOptions, PickedUsersPerf, 'Picked Performance', 'line')
            this.addDataSeries(widget.chartOptions, ReplenUsersPerf, 'Replen Performance', 'line')
              
            widget.chartOptions.xAxis.data = Report_Periods;
            widget.chartOptions.tooltip.formatter = this.tooltipDiffValueFormater;
            widget.chartOptions.xAxis.axisLabel.rotate = 45;
            this.addZoomBar(widget.chartOptions); 
          }
        }
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;
      },
      err => {
        console.log("listenFor broadcastUserActivity error", err);
      }
    );
  }

  remove(widget: any) {
    this._widgetHelper.remove(widget)
  }

  reload(widget: any) {
    this._widgetHelper.reload(widget)
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/userperformance.service.ts